import {
  getProvisionalIdentifierForType,
} from '../util';

class Validation {
  constructor() {
    let data = arguments[0] || {};
    this.id = data.id || getProvisionalIdentifierForType("validation");
    this.type = data.validation_type || null;
    this.target_id = data.target_id || null;
    this.target = data.target || null;
    this.value = 'value' in data ? data.value : null;
  }

  set type(type) {
    this._type = type;
    if (this._description) {
      this._updateDescription();
    }
  }

  get type() {
    return this._type;
  }

  get description() {
    if (!this._description) {
      this._updateDescription();
    }
    return this._description;
  }

  validateResponse(fieldResponse, formResponse = null) {
    if (this.type) {
      return this.type.validateResponseWithValidation(fieldResponse, this, formResponse);
    } else {
      return [this.createValidationError({
        error: "NoValidationTypeProvided",
        message: "ValidationType is required",
      })];
    }
  }

  _updateDescription() {
    if (this.type) {
      this._description = this.type.describeValidation(this);
    } else {
      this._description = 'Unspecified Validation';
    }
  }
}

export default Validation;
